<template>
  <v-text-field
    ref="input"
    v-bind="$attrs"
    v-on="$listeners"
    :outlined="outlined"
    class=""
    v-model="search"
    @click:append="action"
    :append-icon="icone"
    background-color="white"
    :class="{['mb-5']: true, ['upper-text']: true}"
  />
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import db from '@/plugins/dexie';
import errorHandler from '@/utils/error-handler';

export default {
  name: 'CoreTextField',

  props: {
    outlined: {
      type: Boolean,
      default: true,
    },
    modulo: String,
    action: {
      type: Function,
      default: (() => {})
    },
  },

  data() {
    return {
      icone: 'mdi-qrcode-scan',
      search: '',
    };
  },

  computed: {
    $_isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    ...mapState({
      ordem: (state) => state.ordemcarregamento.ordem,
      $$_cacheItem: (state) => state.cache.cache_ordemcarregamentoitem,
    })
  },

  methods: {
    ...mapMutations({
      $_setarOrdem: 'ordemcarregamento/SET_ORDEM',
      $_loadingOrdem: 'ordemcarregamento/SET_LOADING',
      $_limparOrdem: 'ordemcarregamento/CLEAR_ORDEM',
    }),

    ...mapActions({
      $_verificaCompleto: 'ordemcarregamento/verificaCompleto',
    }),

    $_mudaIcone() {
      const element = this.$refs.input;
      setTimeout(() => {
        if (element.value) {
          this.icone = '';
        } else {
          this.icone = 'mdi-qrcode-scan';
        }
      }, 0);
      console.log(element.value);
    },
  },

  mounted() {
    // this.$_mudaIcone();
    if (this.modulo === 'ordem' && this.ordem) this.search = this.ordem.orcidordemcarregamento;
  },

   
   watch: {
    search: {
      deep: true,
      immediate: true,
      async handler() {
        if (!this.search) {
        return;
      }
        if (this.modulo === 'ordem') {
          clearTimeout(this.debounceId);
          this.$_loadingOrdem(true);
          this.debounceId = setTimeout(async () => {
            if (!this.ordem || this.ordem.orcidordemcarregamento !== Number(this.search)) {
              console.log(Number(this.search))
              const ordem = await db.ordemcarregamento.where({ orcidordemcarregamento: Number(this.search) }).first()
              console.log(await db.ordemcarregamento.where({ orcidordemcarregamento: Number(this.search) }).first())
              if (!ordem) {
                errorHandler('Ordem de carregamento não encontrada');
                this.$_loadingOrdem(false);
                this.$_limparOrdem();
                this.search = null;
                return;
              } else if (ordem.orcdatafinalizado) {
                errorHandler('Ordem de carregamento ja foi finalizada.');
                this.$_loadingOrdem(false);
                this.$_limparOrdem();
                this.search = null;
                return;
              } else if (ordem.orcdatafaturamento) {
                errorHandler('Ordem de carregamento ja foi faturada.');
                this.$_loadingOrdem(false);
                this.$_limparOrdem();
                this.search = null;
                return;
              }
              this.$_setarOrdem(ordem);
              await this.$_verificaCompleto(this.$$_cacheItem.filter((i) => i.ociidordemcarregamento === Number(this.search)));
            } 
            this.$_loadingOrdem(false);  
          }, 1000);
        }
      }
    }
  }
};
</script>
<style scoped>
 .upper-text >>> input {
    text-transform: uppercase !important;
  }

</style>
